import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-recipes-management',
  templateUrl: './recipes-management.component.html',
  styleUrls: ['./recipes-management.component.scss'],
})
export class RecipesManagementComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
